import styled from "styled-components";

export const Wrapper = styled.div`
    .custom-collapse .ant-collapse-header {
        padding: 6px 0px !important;
    }

    .custom-collapse .ant-collapse-borderless > .ant-collapse-item {
        border-bottom: 1px solid var(--app-border);
    }

    .ant-select-multiple.ant-select-lg .ant-select-selection-overflow .ant-select-selection-item-content {
        font-size: 11px;
    }

    .ant-select-selector, .ant-input-number-outlined {
        background: var(--app-surface) !important;
        color: var(--app-text-muted) !important;
        min-height: 42px;
    }

    .ant-input-number .ant-input-number-input {
        padding: 9px 11px;
    }

    .ant-select-selection-item {
        font-size: 13px !important;
        font-weight: 500;
    }

    .ant-select-item {
        font-size: .95rem !important;
        font-weight: 500;
    }

    .ant-select .ant-select-arrow {
        height: 22px;
    }

    .ant-select .ant-select-selection-placeholder {
        font-size: 13px !important;
        color: var(--app-text-muted) !important;
        font-weight: 500;
    }

    .ant-picker-input input {
        font-size: 13px
    }

    .ant-picker-range {
        border: 1px solid var(--app-border);
    }

    .ant-select-multiple .ant-select-selection-item-content {
        font-size: 12px;
    }

    .apexcharts-legend-group-vertical {
        flex-direction: row;
        display: flex;
    }

    .card-body .ant-collapse {
        background-color: var(--app-surface-alt);
        border-radius: 2px;
        border: none;
    }

    .card-body .ant-collapse-content {
        background-color: var(--app-surface);
        padding: 12px 20px;
        border-top: 1px solid var(--app-border);
        color: var(--app-text);
    }

    .card-body .ant-collapse-header {
        color: var(--app-text) !important;
    }

    .card-body .ant-collapse-item-active .ant-collapse-header {
        background-color: rgba(99, 206, 148, 0.14);
        color: #50cd89;
    }

    [data-bs-theme="dark"] .card-body .ant-collapse-item-active .ant-collapse-header {
        background-color: rgba(80, 205, 137, 0.2);
        color: #50cd89;
    }

    .card-body .section-header {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
        padding-left: 4px;
        color: var(--app-text);
        border-bottom: 1px solid var(--app-border);
    }

    .account-overview-banner {
        border: 1px solid #63ce94 !important;
        background: rgba(209, 227, 246, 0.85);
    }

    [data-bs-theme="dark"] .account-overview-banner {
        background: rgba(80, 205, 137, 0.12);
        border-color: #50cd89 !important;
    }

    .account-overview-banner .text-green {
        color: #50cd89 !important;
    }

    .net-profit-banner {
        border: 1px dashed #63ce94 !important;
        background: rgba(99, 206, 148, 0.25);
    }

    [data-bs-theme="dark"] .net-profit-banner {
        background: rgba(80, 205, 137, 0.15);
        border-color: #50cd89 !important;
    }

    .metrics-carousel .slick-prev::after,
    .metrics-carousel .slick-next::after {
        content: "" !important;
        display: none !important;
    }

    .metrics-carousel {
        height: 350px;
        overflow: hidden;
        position: relative;
        background: var(--app-surface);
    }

    .carousel-content-scrollable {
        height: 350px;
        overflow-y: auto !important;
        padding-bottom: 10px;
        background: var(--app-surface);
    }

    .metrics-carousel .slick-list,
    .metrics-carousel .slick-track,
    .metrics-carousel .slick-slide > div {
        height: 100%;
    }

    .metrics-carousel .slick-slide > div {
        display: flex;
        flex-direction: column;
    }

    .responsive-select-container {
        width: 100%;
    }

    .custom-select-width {
        width: 100% !important;
        margin-bottom: 10px;
    }

    @media (min-width: 768px) {
        .responsive-select-container {
            flex-direction: row;
            width: auto;
        }

        .custom-select-width {
            width: 200px !important;
            margin-bottom: 0;
        }
    }

    .carousel-tabs {
        display: flex;
        gap: 6px;
        width: 100%;
        padding-bottom: 2px;
    }

    .carousel-tab-btn {
        flex: 1;
        padding: 7px 8px;
        border: 1.5px solid var(--app-border);
        border-radius: 8px;
        background: transparent;
        color: var(--app-text-muted);
        font-size: 12.5px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
        outline: none;
        white-space: nowrap;
        text-align: center;
    }

    .carousel-tab-btn:hover:not(.active) {
        background: var(--app-surface-alt);
        border-color: var(--app-primary-navy);
        color: var(--app-primary-navy);
        transform: translateY(-1px);
    }

    .carousel-tab-btn.active {
        background: var(--app-primary-navy);
        border-color: var(--app-primary-navy);
        color: #ffffff;
        box-shadow: 0 3px 10px rgba(49, 79, 113, 0.35);
    }

    .carousel-tab-btn:focus-visible {
        outline: 3px solid #63CE94;
        outline-offset: 2px;
    }

    canvas {
        width: 100% !important;
    }
`;
